import React, { useState } from "react";
import PropTypes from "prop-types";
import CustomModal from "../CustomModal";
import "./index.scss";

const FEEDBACK_OPTIONS = [
  { id: "pricing", label: "Pricing is too high for my current budget" },
  { id: "features", label: "Features didn't meet my expectations" },
  { id: "short_project", label: "I only needed it for a short project/job search" },
  { id: "other", label: "Other (please specify):" },
];

const ProHunterCancellationModal = ({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [otherText, setOtherText] = useState("");

  const handleSelect = (option) => {
    setSelectedOption(option);
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    if (!selectedOption || loading) return;

    onConfirm({
      reason: selectedOption.label,
      other_text: selectedOption.id === "other" ? otherText.trim() : "",
    });
  };

  const isSubmitDisabled =
    !selectedOption ||
    loading ||
    (selectedOption.id === "other" && !otherText.trim());

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={loading ? () => {} : onClose}
      maxWidth="500px"
      showCloseButton={!loading}
      closeOnOverlayClick={!loading}
    >
      <div className="ph-cancel-modal">
        <div className="ph-cancel-modal__header">
          <div className="ph-cancel-modal__icon-badge">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#2563EB"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              <line x1="9" y1="10" x2="15" y2="10"></line>
              <line x1="12" y1="7" x2="12" y2="13"></line>
            </svg>
          </div>
          <h3 className="ph-cancel-modal__title">Quick Question Before You Go...</h3>
        </div>

        <p className="ph-cancel-modal__subtitle">
          Cancelling your plan will end your ProHunter trial immediately and return your account to the free tier. You will not be charged. Please tell us about your experience before you go:
        </p>

        <div className="ph-cancel-modal__options">
          {FEEDBACK_OPTIONS.map((option) => {
            const isSelected = selectedOption?.id === option.id;

            return (
              <div
                key={option.id}
                className={`ph-cancel-modal__option-card ${
                  isSelected ? "ph-cancel-modal__option-card--selected" : ""
                }`}
                onClick={() => handleSelect(option)}
              >
                <div className="ph-cancel-modal__option-row">
                  <div
                    className={`ph-cancel-modal__radio ${
                      isSelected ? "ph-cancel-modal__radio--checked" : ""
                    }`}
                  />
                  <span className="ph-cancel-modal__option-label">
                    {option.label}
                  </span>
                </div>

                {option.id === "other" && isSelected && (
                  <textarea
                    className="ph-cancel-modal__other-input"
                    placeholder="Type your feedback here..."
                    value={otherText}
                    onChange={(e) => setOtherText(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    maxLength={2000}
                    rows={3}
                  />
                )}
              </div>
            );
          })}
        </div>

        <div className="ph-cancel-modal__footer">
          <button
            type="button"
            className="ph-cancel-modal__cancel-btn"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            type="button"
            className="ph-cancel-modal__submit-btn"
            onClick={handleSubmit}
            disabled={isSubmitDisabled}
          >
            <span>{loading ? "Submitting..." : "Submit"}</span>
            {!loading && (
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="22" y1="2" x2="11" y2="13"></line>
                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
              </svg>
            )}
          </button>
        </div>
      </div>
    </CustomModal>
  );
};

ProHunterCancellationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default ProHunterCancellationModal;
